import React, { Component } from 'react';
import axios from 'axios'
import { Button, Card, Table, Spinner } from 'react-bootstrap'
import { refreshJobInDraft, setJobInDraft } from '../actions/jobDraft';
import { connect } from 'react-redux';

class Slicing extends Component {
    state = {
        gcodeData: {},
        price: 0.00,
        error: null,
        eta: null,
        slicing: true
    }
    interval = null
    componentDidMount() {
        this.interval = setInterval(() => {
            axios.post('/api/model/slice/sts', { job: this.props.jobDraft._id }).then((res) => {
                if (res.data.sts == 3) {
                    this.setState({ slicing: false })
                    clearInterval(this.interval)
                    axios.post('/api/filament/getPrice', { job: this.props.jobDraft._id }).then((res) => {
                        axios.post('/api/jobs/get/estimated/dispatch', { job: this.props.jobDraft._id }).then((res2) => {
                            this.setState({ price: res.data.price, eta: res2.data.eta })
                            this.props.sliced()
                            this.props.refreshJobInDraft(this.props.jobDraft._id)
                        })

                    })
                } else {
                    this.setState({ slicing: true })
                }


            })
        }, 1000)
    }
    componentWillUnmount() {
        clearInterval(this.interval)
    }
    render() {
        let slicing = this.state.slicing
        let darkmode = this.props.user ? this.props.user.darkmode : true

        return (
            <div style={{ width: "100%" }}>

                {slicing ?
                    <div style={{ width: '100%', marginTop: '60px', marginBottom: '60px', margin: "auto" }}>
                        <div style={{ margin: "auto", textAlign: "center" }}>

                            <Spinner animation="border" vaiant="secondary" style={{ width: '50px', height: '50px', fontSize: '30px', margin: "auto", textAlign: "center" }} />
                        </div>
                        <p style={{ margin: "auto", textAlign: "center" }}>Slicing in Progress</p>
                    </div>
                    :
                    <div>
                        {
                            this.state.error ?
                                <div>
                                    {this.state.error}
                                </div>
                                :
                                <div style={{ margin: '30px' }}>

                                    <h2 style={{ textAlign: 'center' }}>
                                        Print Details
                                    </h2>
                                    <div style={{ 'margin': '0px' }} >
                                        <p>Estimated Weight in g: {this.props.jobDraft.filamentGramms}</p>
                                        <p>Estimated Dispatch Date: {this.state.eta}</p>
                                        <p>Cost: £{this.state.price}</p>
                                    </div>

                                </div>

                        }

                    </div>
                }


            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        user: state.user,
        jobDraft: state.jobDraft
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setJobInDraft: (data) => dispatch(setJobInDraft(data)),
        refreshJobInDraft: (jobId) => dispatch(refreshJobInDraft(jobId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Slicing);